import * as tslib_1 from "tslib";
import { FormControlType } from "../../../../../form/schema";
import { FormLocationControl } from "../../../../../form/src/common/controls/form-location-control";
import { FromAddressValueService } from "../../../../../form/src/common/services";
import * as platform from '../../../../../platform';
import { H3Field } from 'h3-mobile-vue';
import { Component, Inject } from "vue-property-decorator";
import wechatJsApi from "wx-jsapi";
let InputLocation = class InputLocation extends FormLocationControl {
    get initMap() {
        return FormLocationControl.service.initMap;
    }
    onClickContent() {
        if (this.readonly || this.readonlyFormula) {
            return false;
        }
        return !this.readonly ? this.onPosition() : this.onNavigation();
    }
    get autoGetLocation() {
        if (!this.getIsNew()) {
            return false;
        }
        if (!this.controlOpts.autoGetLocation) {
            return false;
        }
        else {
            return this.controlOpts.autoGetLocation === 'true';
        }
    }
    get isDingtalk() {
        return platform.IS_DINGTALK;
    }
    get isWechat() {
        return platform.IS_WECHAT;
    }
    mounted() {
        if (this.controlOpts.displayMode === 'accurate' && !this.isEl) {
            if (this.autoGetLocation) {
                this.setCurLoction();
            }
        }
    }
    setCurLoction() {
        const formControls = this.getFormControls();
        const sheetControls = formControls.filter(res => {
            return res.type === FormControlType.Sheet;
        });
        // const l = '{"lat": 22.548602, "lng": 113.944437, "adcode": "440305", "address": "科兴科学园B栋G层16B中国建设银行(科兴微银行)", "cityName": "深圳市", "cityAdcode": "440300", "districtName": "南山区", "provinceName": "广东省", "districtAdcode": "440305", "provinceAdcode": "440000"}'
        const locationContrl = formControls.filter(res => {
            return (res.type === FormControlType.Location
                && res.options.autoGetLocation
                && res.options.autoGetLocation === 'true'
                && res.options.displayMode
                && res.options.displayMode === 'accurate');
        });
        // 
        // sheetControls.forEach((res:any) => {
        //   const locationsKeys = res.columns.map(col => {
        //       if (col.type === FormControlType.Location 
        //         && col.options.autoGetLocation 
        //         && col.options.autoGetLocation === 'true'
        //         && col.options.displayMode
        //         && col.options.displayMode === 'accurate') {
        //           return col.key
        //         }
        //     })
        //     locationsKeys.forEach(loc => {
        //       if (!loc) {
        //         return
        //       }
        //       if (res.controller.value) {
        //         res.controller.value.forEach((sheetVal,index) => {
        //           res.controller.children[index].children[loc].value = Object.assign({}, JSON.parse(l));
        //         })
        //       }
        //     })
        //     
        // });
        const range = 500;
        const self = this;
        FormLocationControl.service.position(range, false).then((result) => {
            let adcode = '';
            if (result.cityAdCode || result.citycode) {
                adcode = result.cityAdCode || result.citycode;
            }
            if (result.districtAdCode || result.adcode) {
                adcode = result.districtAdCode || result.adcode;
            }
            const obj = {
                provinceName: result.province,
                cityName: result.city,
                districtName: result.district,
                address: result.address,
                lat: result.latitude,
                lng: result.longitude,
                adcode
            };
            if (!result.adcode && self.initMap) {
                self.initMap().then((vmap) => {
                    vmap.lazyAMapApiLoaderInstance.load().then(() => {
                        self.initLocation();
                    });
                });
            }
            console.log('当前位置=>', obj);
            FromAddressValueService.setAddressVal(result.adcode).then((value) => {
                const v = Object.assign(obj, value);
                locationContrl.forEach(res => {
                    if (res.controller) {
                        res.controller.value = Object.assign({}, v);
                    }
                });
                // 子表赋值
                sheetControls.forEach((res) => {
                    const locationsKeys = res.columns.map(col => {
                        if (col.type === FormControlType.Location
                            && col.options.autoGetLocation
                            && col.options.autoGetLocation === 'true'
                            && col.options.displayMode
                            && col.options.displayMode === 'accurate') {
                            return col.key;
                        }
                    });
                    locationsKeys.forEach(loc => {
                        if (!loc) {
                            return;
                        }
                        if (res.controller.value) {
                            res.controller.value.forEach((sheetVal, index) => {
                                res.controller.children[index].children[loc].value = Object.assign({}, v);
                            });
                        }
                    });
                });
            });
        });
    }
    initLocation() {
        if (this.isWechat) {
            const vm = this;
            wechatJsApi.getLocation({
                type: "gcj02",
                success: function (res) {
                    let geocoder = new AMap.Geocoder({
                        radius: 1000,
                        extensions: "all",
                    });
                    geocoder.getAddress([res.longitude, res.latitude], (status, result) => {
                        if (status === "complete" && result.info === "OK") {
                            const adComponent = result.regeocode.addressComponent;
                            const add = `${adComponent.township}${adComponent.street}${adComponent.streetNumber}`;
                            const { province, city, district } = adComponent;
                            const backData = {
                                lng: res.longitude,
                                lat: res.latitude,
                                provinceName: province,
                                cityName: city,
                                districtName: district,
                                adcode: adComponent.adcode,
                                address: add,
                            };
                            this.valueChange(backData);
                        }
                    });
                },
                fail: function (err) {
                    console.log(err);
                },
            });
        }
        else {
            const geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                timeout: 10000,
                // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20),
                //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                zoomToAccuracy: true,
                //  定位按钮的排放位置,  RB表示右下
                buttonPosition: "RB",
            });
            const vm = this;
            geolocation.getCurrentPosition((status, result) => {
                if (status === "complete" && result.info === "SUCCESS") {
                    const adComponent = result.addressComponent;
                    const add = `${adComponent.township}${adComponent.street}${adComponent.streetNumber}`;
                    const { province, city, district } = adComponent;
                    const backData = {
                        lng: result.position.lng,
                        lat: result.position.lat,
                        provinceName: province,
                        cityName: city,
                        districtName: district,
                        adcode: result.addressComponent.adcode,
                        address: add,
                    };
                    this.valueChange(backData);
                }
            });
        }
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    get range() {
        let range = 500;
        if (this.controlOpts.range) {
            const rangeMapping = {
                '1km': 1000,
                '500m': 500,
                '200m': 200
            };
            range = rangeMapping[this.controlOpts.range];
        }
        return range;
    }
    onPosition() {
        this.position();
    }
    onNavigation() {
        this.navigation();
    }
    valueChange(val) {
        if (val.adcode) {
            FromAddressValueService.setAddressVal(val.adcode).then((value) => {
                this.ctrl.value = Object.assign(val, value);
            });
        }
        else {
            this.ctrl.value = null;
        }
    }
};
tslib_1.__decorate([
    Inject()
], InputLocation.prototype, "layoutTypeFn", void 0);
InputLocation = tslib_1.__decorate([
    Component({
        name: "input-location",
        components: {
            H3Field,
            SmartLocation: () => import('../../../../../form/src/common/components/mobile-smart-location/smart-location.vue')
        }
    })
], InputLocation);
export default InputLocation;
